import { styled, globalStitches } from '@eneco/sparky/stitches';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ArticleImageContainer: any = styled('div', {
  position: 'relative',
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ArticleImageHeadingContainer: any = styled('div', {
  position: 'absolute',
  width: '100%',
  bottom: 0,
});

export const globalStyles = globalStitches({
  body: {
    backgroundColor: '$backgroundPrimary !important',
  },
});
